import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { fetchUnitDetails } from "actions/Units";
import TabbedSection from "components/TabbedSection";
import UnitSettingsDeviceModal from "app/routes/Sites/routes/Display/UnitsUsers/UnitSettings/UnitSettingsDeviceModal";
import UnitSettingsManageKeysModal from "app/routes/Sites/routes/Display/UnitsUsers/UnitSettings/UnitSettingsManageKeysModal";

const UnitSettingsModal = ({ uuDetail, updateLocalRentalState, unitUserId }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const authUser = useSelector(state => state.auth.authUser);

  useEffect(() => {
    dispatch(fetchUnitDetails(uuDetail.unit.uuid));
  }, [dispatch, uuDetail.unit.uuid]);

  const allTabs = [
    { 
      tab: "Device", 
      label: intl.formatMessage({ id: "pages.devices.Type" }), 
      showLabel: true, 
      permission: "manage_locks" 
    },
    { 
      tab: "Manage Keys", 
      label: intl.formatMessage({ id: "pages.keys.manage" }), 
      showLabel: true, 
      permission: "support_rekey" 
    },
  ];

  const tabs = allTabs.filter(tab => authUser?.permissions?.includes(tab.permission));

  const tabComponents = {
    Device: <UnitSettingsDeviceModal updateLocalRentalState={updateLocalRentalState} unitUserId={unitUserId} />,
    "Manage Keys": <UnitSettingsManageKeysModal />,
  };

  return (
    <TabbedSection topPadding={false} tabs={tabs} defaultTab="Device">
      {tabComponents}
    </TabbedSection>
  )
};

export default UnitSettingsModal;